function IconMarketplaceCrossLock({
  size = 16,
  color = '#C1C2C5',
  slashOutlineColor = '#FFFFFF',
  backgroundColor = '#FFFFFF',
}: {
  size?: number;
  color?: string;
  slashOutlineColor?: string;
  backgroundColor?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="6.667" fill={backgroundColor} />
      <path
        d="M7.99943 1.33398C11.6814 1.33398 14.6661 4.31865 14.6661 8.00065C14.6661 9.76876 13.9637 11.4645 12.7135 12.7147C11.4632 13.9649 9.76754 14.6673 7.99943 14.6673C6.23132 14.6673 4.53563 13.9649 3.28539 12.7147C2.03514 11.4645 1.33276 9.76876 1.33276 8.00065C1.33276 4.31865 4.31743 1.33398 7.99943 1.33398ZM9.33276 4.66732C8.84268 4.66724 8.36963 4.84711 8.0034 5.17278C7.63718 5.49845 7.40327 5.94725 7.3461 6.43398L7.3361 6.54998L7.33276 6.66732L7.3361 6.78465C7.34876 6.99732 7.3941 7.20065 7.46743 7.38998L7.52743 7.52932L5.1941 9.86265L5.13943 9.92532C5.04872 10.0422 4.99949 10.186 4.99949 10.334C4.99949 10.482 5.04872 10.6257 5.13943 10.7427L5.19476 10.8053L6.19476 11.8053L6.25743 11.8607C6.37435 11.9514 6.51812 12.0006 6.6661 12.0006C6.81408 12.0006 6.95785 11.9514 7.07476 11.8607L7.13743 11.8053L7.19276 11.7427C7.28347 11.6257 7.33271 11.482 7.33271 11.334C7.33271 11.186 7.28347 11.0422 7.19276 10.9253L7.13743 10.8627L6.60943 10.334L6.99943 9.94398L7.5281 10.472L7.59076 10.5273C7.71904 10.6267 7.87918 10.676 8.04116 10.6657C8.20314 10.6555 8.35583 10.5866 8.47059 10.4718C8.58535 10.357 8.65431 10.2044 8.66453 10.0424C8.67475 9.8804 8.62553 9.72026 8.5261 9.59198L8.47076 9.52932L7.94276 9.00065L8.47076 8.47265C8.74163 8.60179 9.03808 8.66831 9.33816 8.66731C9.63823 8.6663 9.93423 8.59778 10.2042 8.46683C10.4742 8.33589 10.7113 8.14586 10.8979 7.91084C11.0844 7.67582 11.2157 7.40183 11.282 7.10917C11.3483 6.81651 11.3479 6.51269 11.2808 6.22021C11.2137 5.92773 11.0817 5.65409 10.8945 5.41958C10.7073 5.18506 10.4697 4.99568 10.1994 4.86545C9.92902 4.73523 9.63284 4.66752 9.33276 4.66732ZM9.33276 6.00065C9.50957 6.00065 9.67914 6.07089 9.80417 6.19591C9.92919 6.32094 9.99943 6.49051 9.99943 6.66732C9.99943 6.84413 9.92919 7.0137 9.80417 7.13872C9.67914 7.26375 9.50957 7.33398 9.33276 7.33398C9.15595 7.33398 8.98638 7.26375 8.86136 7.13872C8.73634 7.0137 8.6661 6.84413 8.6661 6.66732C8.6661 6.49051 8.73634 6.32094 8.86136 6.19591C8.98638 6.07089 9.15595 6.00065 9.33276 6.00065Z"
        fill={color}
      />
      <rect
        x="0.769728"
        y="1.3663"
        width="2.4"
        height="18.8546"
        rx="1.2"
        transform="rotate(-36.7715 0.769728 1.3663)"
        fill={color}
        stroke={slashOutlineColor}
        strokeWidth="0.8"
      />
    </svg>
  );
}
IconMarketplaceCrossLock.displayName = 'IconMarketplaceCrossLock';

export { IconMarketplaceCrossLock };
